// extracted by mini-css-extract-plugin
export default {"dialog":"WelderSelection_tsx_dialog__g0DyI","container":"WelderSelection_tsx_container__5630m"};